import { IGetManutencaoGerenciarArquivoByIdUseCase } from "../../../presentation/useCases/read/get_manutencao_gerenciar_arquivo_by_id_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * GetManutencaoGerenciarArquivoByIdUseCase
 */

export class GetManutencaoGerenciarArquivoByIdUseCase implements IGetManutencaoGerenciarArquivoByIdUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async execute(
    idManutencao: number,
    nroArquivo: number,
    imageName: string,
  ): Promise<void> {
    const blob = await this.repository.getManutencaoGerenciarArquivoById(idManutencao, nroArquivo);

    if (!blob) throw new Error('Falha ao buscar dados da imagem!');

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', String(imageName));
    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);
  }
}
